<template>
  <section class="today-matches">

    <div class="section-header">

      <h2>بازی‌های امروز</h2>

      <router-link
          to="/Matches"
          class="view-all-btn"
      >
        همه بازی‌ها
      </router-link>

    </div>

    <div class="matches">

      <article
          class="match-card clickable"
          v-for="match in displayedMatches"
          :key="match.id"
          @click="$router.push(`/match/${match.id}`)"
      >

        <span class="competition">
        {{ getLeagueName(match.competition?.name) || 'نامشخص' }}
        </span>

        <div class="teams">

          <!-- HOME -->
          <div class="team clickable-team" @click.stop="$router.push(`/team/${match.home?.id}`)">

            <img
                v-if="match.home?.logo"
                :src="match.home.logo"
                :alt="match.home.name"
            >

            <span>
                  {{ getTeamName(match.home?.name) || 'نامشخص' }}
            </span>

          </div>


          <!-- TIME / SCORE -->
          <span class="time">

            {{
              new Date(match.kickoffAt).toLocaleTimeString(
                  'fa-IR',
                  {
                    hour: '2-digit',
                    minute: '2-digit'
                  }
              )
            }}

          </span>


          <!-- AWAY -->
          <div class="team clickable-team" @click.stop="$router.push(`/team/${match.away?.id}`)">

            <img
                v-if="match.away?.logo"
                :src="match.away.logo"
                :alt="match.away.name"
            >

            <span>
                  {{ getTeamName(match.away?.name) || 'نامشخص' }}
            </span>

          </div>

        </div>

      </article>

    </div>

  </section>
</template>


<script>
import api from '@/services/api'
import {teamNames, leagueNamesLatin} from '@/utils/translations'

export default {

  name: 'TodayMatches',

  data() {

    return {

      matches: [],

      loading: true,

      error: null,

      // ترتیب اولویت لیگ‌ها
      priorityOrder: [
        'PL',
        'PD',
        'SA',
        'BL1',
        'PPL',
        'DED',
        'BSA'
      ]

    }

  },

  methods: {

    getTeamName(englishName) {
      return teamNames[englishName] || englishName;
    },
    getLeagueName(englishName) {
      return leagueNamesLatin[englishName] || englishName;
    }

  },
  computed: {

    displayedMatches() {

      const matches = [...this.matches]

      // مرتب‌سازی بر اساس اولویت لیگ
      matches.sort((a, b) => {

        const aIndex =
            this.priorityOrder.indexOf(
                a.competition?.shortName
            )

        const bIndex =
            this.priorityOrder.indexOf(
                b.competition?.shortName
            )

        // لیگ‌هایی که در لیست نیستند بروند آخر
        const safeA =
            aIndex === -1
                ? 999
                : aIndex

        const safeB =
            bIndex === -1
                ? 999
                : bIndex

        if (safeA !== safeB) {
          return safeA - safeB
        }

        // اگر لیگ یکی بود، بازی زودتر اول باشد
        return new Date(a.kickoffAt) -
            new Date(b.kickoffAt)

      })

      // فقط ۳ کارت
      return matches.slice(0, 3)

    }

  },


  async mounted() {

    try {

      const response =
          await api.getTodayMatches()

      console.log(
          '🔥 TODAY VUE RESPONSE:',
          response
      )

      this.matches =
          response.matches || []

      console.log(
          '🔥 TODAY DISPLAYED MATCHES:',
          this.displayedMatches
      )

    } catch (error) {

      console.error(
          'خطا در دریافت بازی‌های امروز:',
          error
      )

      this.error =
          'دریافت بازی‌ها با خطا مواجه شد'

    } finally {

      this.loading = false

    }

  }

}
</script>


<style scoped lang="scss">

.today-matches {
  margin-block: 28px;
  padding: 10px 10px 30px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, .08);
  border-radius: 8px;
}


.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}


.section-header h2 {
  margin: 0;
  font-size: 1.2rem;
}


.section-header a {
  font-size: 0.8rem;
}


.matches {
  display: flex;
  grid-template-columns: repeat(3, 1fr);
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
}


.match-card {
  min-width: 0;
  padding: 10px 12px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.07);
}

.match-card.clickable {
  cursor: pointer;
  transition: .2s;
}

.match-card.clickable:hover {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.13);
  transform: translateY(-2px);
}


.competition {
  display: block;
  margin-bottom: 8px;
  color: #777;
  font-size: 0.9rem;
  text-align: center;
}


.teams {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  gap: 12px;
}


.team {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.clickable-team {
  cursor: pointer;

  &:hover span {
    color: #2563eb;
    text-decoration: underline;
  }
}


.team:last-child {
  justify-content: flex-end;
  text-align: right;
}


.team img {
  width: 20px;
  height: 20px;
  object-fit: contain;
  flex-shrink: 0;
}


.team span {
  min-width: 0;
  font-size: 0.85rem;
  line-height: 1.2;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}


.time {
  font-size: 0.75rem;
  font-weight: 700;
  white-space: nowrap;
}

.view-all-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;

  padding: 9px 16px;

  background: linear-gradient(135deg, #081c15, #14532d);
  color: #fff;

  border: 1px solid rgba(66, 211, 146, 0.25);
  border-radius: 10px;

  font-size: 0.8rem;
  font-weight: 600;

  text-decoration: none;

  box-shadow: 0 4px 12px rgba(8, 28, 21, 0.15);

  transition: transform 0.2s ease,
  box-shadow 0.2s ease,
  background 0.2s ease;
}

.view-all-btn span {
  font-size: 1rem;
  transition: transform 0.2s ease;
}

.view-all-btn:hover {
  background: linear-gradient(135deg, #14532d, #166534);

  transform: translateY(-2px);

  box-shadow: 0 7px 18px rgba(8, 28, 21, 0.22);
}

.view-all-btn:hover span {
  transform: translateX(-4px);
}

.view-all-btn:active {
  transform: translateY(0);
}

@media (max-width: 1199px) {

  .matches {
    grid-template-columns: repeat(2, 1fr);
  }

}


@media (max-width: 767px) {

  .matches {
    grid-template-columns: 1fr;
  }

  .match-card {
    padding: 9px 12px;
  }
  .view-all-btn {
    padding: 7px 11px;
    border-radius: 9px;
    font-size: 0.7rem;
    gap: 5px;
  }

  .view-all-btn span {
    font-size: 0.85rem;
  }
}

</style>